const findLoginPwdRouter = {
  path: '',
  component: () => import('@/views/security/findLogin'),
  redirect: 'findLoginPwd',
  name: '找回密码',
  meta: {
    title: '找回密码',
    icon: 'el-icon-s-home'
  },
  children: [
    {
      path: 'findLoginPwd',
      name: '找回密码',
      meta: {
        title: '找回密码'
      },
      component: () => import('@/views/security/findLogin')
    }

  ]
}

export default findLoginPwdRouter
